import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"z-index":"1002"},
  class: "flex md:flex-row flex-col items-center bg-dark fixed top-0 left-0 w-full md:h-14 shadow-elevation bg-opacity-90 px-2"
}
const _hoisted_2 = { class: "flex items-center w-full" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "close", -1)
const _hoisted_5 = {
  class: "text-lightText flex md:flex-row flex-col items-center space-x-4 md:ml-4 overflow-hidden",
  style: {"text-overflow":"ellipsis"}
}
const _hoisted_6 = { class: "hidden md:block" }
const _hoisted_7 = {
  class: "md:hidden w-full overflow-hidden",
  style: {"text-overflow":"ellipsis"}
}
const _hoisted_8 = {
  key: 0,
  class: "text-sm opacity-70 hidden md:block"
}
const _hoisted_9 = { class: "md:ml-auto md:mt-0 -mt-3 flex items-center text-lightText" }
const _hoisted_10 = {
  key: 0,
  class: "text-sm opacity-70 md:hidden"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "file_download", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "zoom_in", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "zoom_out", -1)
const _hoisted_14 = {
  style: {"z-index":"1001"},
  class: "mt-14 fixed top-1/2 transform -translate-y-1/2 -translate-x-1/2 left-1/2 overflow-y-auto h-screen"
}
const _hoisted_15 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_LinearProgress = _resolveComponent("LinearProgress")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "fixed h-screen w-screen top-0 left-0 bg-dark bg-opacity-60",
      style: {"z-index":"1000"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewerClose')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Btn, {
            class: "md:mr-2",
            variant: 'icon',
            outline: true,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('viewerClose')))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.filename), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.filename), 1),
          (_ctx.pageCount !== null)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.pageCount) + " " + _toDisplayString(_ctx.pageCount === 1 ? _ctx.$t("misc.page") : _ctx.$t("misc.pages")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.pageCount !== null)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.pageCount) + " " + _toDisplayString(_ctx.pageCount === 1 ? _ctx.$t("misc.page") : _ctx.$t("misc.pages")), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_Btn, {
          class: "md:mr-2",
          loading: _ctx.downloading,
          variant: 'icon',
          outline: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('download')))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_Btn, {
          class: "",
          variant: 'icon',
          outline: true,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onZoom(100)))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_Btn, {
          variant: 'icon',
          outline: true,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onZoom(-100)))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.isLoading || _ctx.downloading)
              ? (_openBlock(), _createBlock(_component_LinearProgress, {
                  key: 0,
                  class: "z-50 absolute top-0"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vue_pdf_embed, {
          id: _ctx.id,
          width: _ctx.width,
          ref: "pdfRef",
          source: _ctx.base64Source,
          page: _ctx.page,
          onProgress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onProgress($event))),
          onRendered: _ctx.handleDocumentRender
        }, null, 8, ["id", "width", "source", "page", "onRendered"])
      ])
    ])
  ], 64))
}